import { useEffect, useState } from "react";
export var useMediaQuery = function (query) {
    var mediaMatch = window.matchMedia(query);
    var _a = useState(mediaMatch.matches), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        var updateMatches = function () { return setMatches(mediaMatch.matches); };
        mediaMatch.addEventListener("change", updateMatches);
        updateMatches();
        return function () { return mediaMatch.removeEventListener("change", updateMatches); };
    }, [mediaMatch]);
    return matches;
};
//# sourceMappingURL=useMediaQuery.js.map